<template>
  <div class="container">
    <v-layout row justify-center>
      <v-flex xs12 lg6>
        <v-card class="dash-card elevation-3">
          <v-card-title primary-title>
            <v-layout row>
              <v-flex>
                <div class="headline">{{ getString('Quick Calendar!') }}</div>
                <span class="grey--text">Calendario portatile da avere sempre con te</span>
              </v-flex>
              <v-flex style="text-align:right">
                <!-- <img src="../../../static/img/quadrato.png" class="logo-size" style="display:inline-block" /> -->
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <p>
              {{ getString("Quick Cal è nato dall'esigenza di avere il calendario portatile di QuickBe sempre a portata di mano, con le notifiche e la possibilità di interazione")}}
              <br />
              <b>{{ getString("Istruzioni d'uso") }}</b>
              <br />
              {{ getString('Visita con lo smartphone il link: https://www.ocarrellènumostr.it e poi (istruzioni installazione app ios / android) ')}}
              {{ getString('Poi non ti resta che inquadrare il QR Code ed il gioco è fatto!) ') }}
            </p>
            <canvas id="canvas" />


          </v-card-text>
          <!-- <v-card-actions>
            <v-btn flat color="orange" @click="openDewStudio">{{getString('Visita Dew Studio')}}</v-btn>
          </v-card-actions> -->
        </v-card>
      </v-flex>
    </v-layout>
    {{ token }}

  </div>
</template>

<script>
import QRCode from "qrcode";
export default {
  name: "QCal",
  destroyed: function ()
  {

  },
  mounted: function ()
  {
    this.init();
  },
  methods: {
     getString: function(key, values) {
      return this.$store.state.currentTranslator.getString(key, values)
    },
    init: function ()
    {
      var canvas = document.getElementById('canvas')
      QRCode.toCanvas(canvas, localStorage.getItem("_rccarriage_5t_puorcnfam"), function (error)
      {
        if (error) console.error(error)
        console.log('success!');
      })
    }
  },
  data: function ()
  {
    return {

    };
  }
};
</script>

<style scoped>

#canvas{

}
.center {
  text-align: center;
}

.border {
  border: 2px solid;
}

.logo-size {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/QCal.vue